import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-black/20" data-id="element-104">
      <div className="max-w-4xl mx-auto" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-green-900/20 to-black border-2 border-green-500/50 rounded-2xl p-8 md:p-12 text-center shadow-2xl" data-id="element-106">
          <motion.div initial={{
          scale: 0
        }} whileInView={{
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} data-id="element-107">
            <ShieldCheckIcon className="w-20 h-20 text-green-500 mx-auto mb-6" data-id="element-108" />
          </motion.div>

          <h2 className="text-3xl md:text-4xl font-black mb-6 text-green-400" data-id="element-109">
            Garantía de Satisfacción de 7 Días
          </h2>

          <p className="text-lg md:text-xl text-gray-200 leading-relaxed" data-id="element-110">
            Compra el sistema, aplícalo. Si en 7 días sientes que esto no es
            para ti, envíanos un correo y te devolvemos el 100% de tu dinero.{' '}
            <span className="text-green-400 font-semibold" data-id="element-111">
              Sin preguntas, sin resentimientos.
            </span>{' '}
            El riesgo es todo mío.
          </p>
        </motion.div>
      </div>
    </section>;
}